module.exports = __webpack_public_path__ + "img/5.5a8b0cd3.jpg";